import type {Component} from "vue"
import type {AppSettingDefinitionInfo} from "@/backend/apps.types"
import BooleanEditor from "./BooleanEditor.vue"
import SelectEditor from "./SelectEditor.vue"
import TextEditor from "./TextEditor.vue"

export function resolveEditorComponent(
  definition: AppSettingDefinitionInfo
): Component {
  const type = (definition.editor?.type as string) ?? "text"
  switch (type) {
    case "boolean":
      return BooleanEditor
    case "select":
      return SelectEditor
    case "text":
    default:
      return TextEditor
  }
}

export { BooleanEditor, SelectEditor, TextEditor }
